import { Link, useParams } from '@tanstack/react-router'
import { CalendarX2Icon, HomeIcon, RefreshCwIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { Button } from '@/components'
import { useCheckout } from '@/modules/account'
import { BaseError } from './BaseError'

const ProjectExpired = forwardRef<HTMLDivElement>((props, ref) => {
  const { slug } = useParams({ strict: false })
  const { renewProject } = useCheckout()

  const renew = () => {
    if (slug) renewProject(slug)
  }

  return (
    <BaseError
      title="Project Expired"
      description="This project has expired. Renew it to keep working with your data."
      icon={CalendarX2Icon}
      {...props}
      ref={ref}
    >
      <Button onClick={renew} disabled={!slug}>
        <RefreshCwIcon className="size-4" />
        Renew project
      </Button>
      <Button asChild theme="outline">
        <Link to="/projects">
          <HomeIcon className="size-4" />
          Back to projects
        </Link>
      </Button>
    </BaseError>
  )
})

ProjectExpired.displayName = 'ProjectExpired'

export { ProjectExpired }
